import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import StaffApproval from '../views/staff/approval.vue'
import StaffInfo from '../views/staff/info.vue'
import CustomerServiceSettings from '../views/settings/customer-service.vue'
import ActivitySettings from '../views/settings/activity.vue'
import CleaningSettings from '../views/settings/cleaning.vue'
import MealSettings from '../views/settings/meal.vue'
import LifeCareSettings from '../views/settings/life-care.vue'
import CustomServiceSettings from '../views/settings/personalized.vue'
import NoticeSettings from '../views/settings/notice.vue'
import OrderStatistics from '../views/OrderStatistics.vue'
import NursingCenter from '../views/NursingCenter.vue'
import UserInfo from '../views/UserInfo.vue'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () => import('../views/Orders.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/:type',
    name: 'OrderList',
    component: () => import('../views/OrderList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/staff/approval',
    name: 'StaffApproval',
    component: StaffApproval,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/staff/info',
    name: 'StaffInfo',
    component: StaffInfo,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/activity',
    name: 'ActivitySettings',
    component: ActivitySettings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/cleaning',
    name: 'CleaningSettings',
    component: CleaningSettings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/meal',
    name: 'MealSettings',
    component: MealSettings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/life-care',
    name: 'LifeCareSettings',
    component: LifeCareSettings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/custom-service',
    name: 'CustomServiceSettings',
    component: CustomServiceSettings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/customer-service',
    name: 'CustomerServiceSettings',
    component: CustomerServiceSettings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings/notice',
    name: 'NoticeSettings',
    component: NoticeSettings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/order-statistics',
    name: 'OrderStatistics',
    component: OrderStatistics,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/nursing-center',
    name: 'NursingCenter',
    component: NursingCenter,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/user-info',
    name: 'UserInfo',
    component: UserInfo,
    meta: {
      requiresAuth: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !store.state.isLoggedIn) {
    next('/')
  } else {
    next()
  }
})

export default router 